import { useCallback } from 'react';
import { type NavigateOptions, useLocation, useNavigate } from 'react-router-dom';
import { orgHref } from '@/lib/utils/orgRoutes';

/**
 * ``useNavigate`` that prefixes org-less app paths with the active org from the
 * current URL, so programmatic navigation stays inside the org-scoped scheme.
 *
 * :return: a navigate function accepting an org-less path (e.g. ``/scenarios``)
 */
export function useOrgNavigate(): (to: string, options?: NavigateOptions) => void {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: string, options?: NavigateOptions) => {
      navigate(orgHref(to, location.pathname), options);
    },
    [navigate, location.pathname]
  );
}
